<template>
  <main class="main-content">
    <div class="card">
      <div class="card-body">
        <h6 class="card-title">ایجاد پروژه</h6>
        <form class="border" @submit.prevent="onSubmit" @keydown="form.errors.clear($event.target.name)" enctype="multipart/form-data">
          <div class="border">
            <h5>اطلاعات مشتری</h5>
            <div class="d-flex justify-content-center py-4">
              <div class="col-5">
                <button type="button" :class="[ butt=='customer' ? 'btn btn-outline-warning btn-block active' : 'btn btn-outline-warning btn-block']" @click="butt='customer'">انتخاب بین مشتریان</button>
              </div>
              <div class="col-5">
                <button type="button" :class="[ butt=='newCustomer' ? 'btn btn-outline-dark btn-block active' : 'btn btn-outline-dark btn-block']" @click="newCustomer()">مشتری جدید</button>
              </div>
            </div>
            <div v-if="butt=='customer'">
              <div class="form-row d-flex justify-content-center" >
                <div class="col-md-10 mb-3">
                  <label for="validationCustom01">جستجو بر اساس موبایل و اسم مشتری
                      <span class="text-danger">*</span>
                  </label>
                  <input type="text" class="form-control" placeholder="موبایل یا اسم راوارد کنید" @keyup="debounceInput" v-model="searchkey">
                </div>
              </div>
              <div class="form-row d-flex justify-content-center" v-if="customers">
                <div class="col-md-10 mb-3">
                  <label for="validationCustom01">مشتریان
                      <span class="text-danger">*</span>
                  </label>
                  <select class="form-control" v-model="form.customer_id" name="customer_id"
                  @change="choose">
                  <option v-for="customer in customers" :key="customer.id" :value="customer.id">{{customer.name + '-' + customer.mobile}}</option>
                  </select>
                  <span class="help text-danger" v-if="form.errors.has('phone')" v-text="form.errors.get('phone')"></span>
                </div>
              </div>
            </div>
            <div>
              <div class="form-row d-flex justify-content-center">
                <div class="col-md-3 mb-3">
                    <label for="validationCustom01">نام مشتری
                        <span class="text-danger">*</span>
                    </label>
                    <input type="text" class="form-control" placeholder="نام مشتری را وارد کنید!" name="first_name" v-model="form.first_name"
                    :disabled="butt=='customer'">
                    <span class="help text-danger" v-if="form.errors.has('first_name')" v-text="form.errors.get('first_name')"></span>
                </div>
                <div class="col-md-3 mb-3">
                    <label for="validationCustom02">نام خانوادگی مشتری
                        <span class="text-danger">*</span>
                    </label>
                    <input type="text" class="form-control" placeholder="نام خانوادگی مشتری را وارد کنید!"
                        name="last_name" v-model="form.last_name" :disabled="butt=='customer'">
                    <span class="help text-danger" v-if="form.errors.has('last_name')" v-text="form.errors.get('last_name')"></span>
                </div>
                <div class="col-md-3 mb-3">
                    <label for="validationCustom02">کد ملی
                    </label>
                    <input type="text" class="form-control" placeholder="کد ملی را وارد کنید!" name="identification" v-model="form.identification"
                    :disabled="butt=='customer'">
                    <span class="help text-danger" v-if="form.errors.has('identification')" v-text="form.errors.get('identification')"></span>
                </div>
              </div>
              <div class="form-row d-flex justify-content-center">
                  <div class="col-md-3 mb-3">
                      <label for="validationCustom02">تلفن همراه
                          <span class="text-danger">*</span>
                      </label>
                      <input type="number" class="form-control" placeholder="شماره موبایل را وارد کنید!"
                          name="mobile" v-model="form.mobile"
                          :disabled="butt=='customer'">
                      <span class="help text-danger" v-if="form.errors.has('mobile')" v-text="form.errors.get('mobile')"></span>
                  </div>
                  <div class="col-md-3 mb-3">
                      <label for="validationCustom02">تلفن همراه(دوم)
                      </label>
                      <input type="number" class="form-control" placeholder="شماره موبایل را وارد کنید!"
                          name="mobile2"  v-model="form.mobile2"
                          :disabled="butt=='customer'">
                      <span class="help text-danger" v-if="form.errors.has('mobile2')" v-text="form.errors.get('mobile2')"></span>
                  </div>
                  <div class="col-md-3 mb-3">
                      <label for="validationCustom02">تلفن ثابت

                      </label>
                      <input type="number" class="form-control" placeholder="شماره تلفن را وارد کنید!" name="phone" v-model="form.phone"
                      :disabled="butt=='customer'">
                      <span class="help text-danger" v-if="form.errors.has('phone')" v-text="form.errors.get('phone')"></span>
                  </div>
              </div>
              <div class="form-row d-flex justify-content-center">
                  <div class="col-md-6 mb-3">
                      <label for="validationCustom02">آدرس ایمیل
                      </label>
                      <input type="email" class="form-control" placeholder="آدرس ایمیل را وارد کنید!" name="email" v-model="form.email"
                      :disabled="butt=='customer'">
                      <span class="help text-danger" v-if="form.errors.has('email')" v-text="form.errors.get('email')"></span>
                  </div>
              </div>
            </div>
          </div>
          <div class="border">
            <h5>اطلاعات پروژه</h5>
            <div class="form-row d-flex justify-content-center">
              <div class="col-md-4 mb-3">
                  <label for="validationCustom01">عنوان
                      <span class="text-danger">*</span>
                  </label>
                  <input type="text" class="form-control" placeholder="عنوان پروژه را وارد کنید!" name="name" v-model="form.name">
                  <span class="help text-danger" v-if="form.errors.has('name')" v-text="form.errors.get('name')"></span>
              </div>
              <div class="col-md-4 mb-3">
                <label for="validationCustom01">انتخاب روش آشنایی
                  <span class="text-danger">*</span>
                </label>
                <v-select v-model="form.introduction" :options="options" name="introduction" label="introduction"></v-select>
                <span class="help text-danger" v-if="form.errors.has('introduction')" v-text="form.errors.get('introduction')"></span>
              </div>
            </div>
            <div class="form-row d-flex justify-content-center">
                <div class="col-md-4 mb-3">
                  <label for="validationCustom02">آدرس
                      <span class="text-danger">*</span>
                  </label>
                  <input type="text" class="form-control" placeholder="آدرس را وارد کنید!" name="address" v-model="form.address">
                  <span class="help text-danger" v-if="form.errors.has('address')" v-text="form.errors.get('address')"></span>
                </div>
                <div class="col-md-4 mb-3">
                  <label for="validationCustom02">توضیحات
                  </label>
                  <input type="text" class="form-control" placeholder="توضیحات را وارد کنید!" name="description" v-model="form.description">
                  <span class="help text-danger" v-if="form.errors.has('description')" v-text="form.errors.get('description')"></span>
                </div>
            </div>
          </div>
          <div class="btn-group d-flex justify-content-center">
            <button class="btn btn-success col-md-2 my-3 btn-pulse" type="submit"
              :disabled="form.errors.any()">ذخیره</button>
            <router-link :to="{name: 'projects.index'}" class="btn btn-dark col-md-2 my-3" type="button"><span
                class="text-white">بازگشت</span></router-link>
          </div>
        </form>
      </div>
    </div>
  </main>
</template>
<script>
import _ from 'lodash'
export default {
  name: 'StaffCreate',
  mounted () {
    this.$send.submit('get', 'api/projects/create')
      .then(response => {
        this.options = response
      })
  },
  data () {
    return {
      profile: null,
      options: [],
      searchkey: null,
      butt: 'newCustomer',
      customers: null,
      form: new this.$form({
        customer_id: null,
        first_name: '',
        last_name: '',
        identification: '',
        mobile: '',
        mobile2: '',
        phone: '',
        email: '',
        name: '',
        introduction: '',
        address: '',
        description: ''
      })
    }
  },
  methods: {
    onSubmit () {
      this.$send.submit('post', 'api/projects', this.form.data())
        .then(response => {
          this.form.onSuccess(response)
          // eslint-disable-next-line no-undef
          swal(
            'تبریک!',
            'پروژه جدید با موفقیت ایجاد شد!',
            'success', {
              button: 'باشه'
            })
          this.$router.push({
            name: 'projects.index'
          })
        }).catch(error => {
          this.form.onFail(error.errors)
        })
    },
    choose () {
      this.form.errors.clear('customer_id')
      const custom = this.customers.find(x => x.id === this.form.customer_id)
      console.log(custom)
      this.form.first_name = custom.name.split(' ')[0]
      this.form.last_name = custom.name.split(' ')[1]
      this.form.identification = custom.identification
      this.form.mobile = custom.mobile
      this.form.mobile2 = custom.mobile2
      this.form.phone = custom.phone
      this.form.email = custom.email
    },
    debounceInput: _.debounce(function () {
      this.search()
    }, 800),
    search () {
      this.$send.submit('post', 'api/sms/search/customer', { search: this.searchkey })
        .then(response => {
          this.customers = response
        })
    },
    newCustomer () {
      this.butt = 'newCustomer'
      this.form.customer_id = null
      this.form.first_name = ''
      this.form.last_name = ''
      this.form.identification = ''
      this.form.mobile = ''
      this.form.mobile2 = ''
      this.form.phone = ''
      this.form.email = ''
    }
  }
}

</script>
